import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rti-grid',
  templateUrl: './rti-grid.component.html',
  styleUrls: ['./rti-grid.component.css']
})
export class RtiGridComponent implements OnInit {
   title="View RTI"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/RTI/rti-grid/rti-grid.component.ts